import React from 'react';
import axios from 'axios';

import { useTimeModal } from '../Components/TimeModal/TimeModalContext';

import HeaderPanel from '../Components/HeaderPanel';

import Loading from '../Components/Loading';

const ViewFeedback = () => {
    const { openTimeModal } = useTimeModal();
    const [feedbacks, setFeedbacks] = React.useState([]);
    const [warning, setWarning] = React.useState('');
    const [loading, setLoading] = React.useState(true);
    const [reload, setReload] = React.useState(true);

    React.useEffect(() => {
      axios.get(`/api/feedbacks`)
      .then(response => {
          if (response.data.length === 0) {
            setWarning('Нет обращений в базе данных.');
            setFeedbacks([]);
          } else {
            setWarning('');
            setFeedbacks(response.data);
          }
      })
      .catch(error => {
        setWarning(`Ошибка при загрузке таблицы обращений обратной связи:  ${error.response?.data.message || error.message}`);
      })
      .finally(() => {
        setReload(false);
        setLoading(false);
      });
    }, [reload]);

    const changeStatusFeedback = (e, feedbackIdForChangeStatus) => {
      e.preventDefault();
  
      axios.put(`/api/feedback?id=${feedbackIdForChangeStatus}`)
      .then(() => {
        openTimeModal('Статус обращения изменён', 'success');
        setReload(true);
      })
      .catch((error) => {
        openTimeModal(`Не удалось изменить статус обращения. ${error.response?.data.message || error.message}`, 'error');
      });
  };
    
    const deleteFeedback = (e, feedbackIdForDelete) => {
      e.preventDefault();
      
      axios.delete(`/api/feedback?id=${feedbackIdForDelete}`)
      .then(() => {
        openTimeModal('Обращение удалено', 'success');
        setReload(true);
      }
      )
      .catch((error) => {
        openTimeModal(`Не удалось удалить обращение. ${error.response?.data.message || error.message}`, 'error');
      });
    };
  
  

    return (
        <div className='mainContainer'>
            <h1>Просмотр обращений обратной связи</h1>
            <HeaderPanel typePanel='Назад' />
            <div className='tableDescription'><h2>Обращения в поддержку</h2></div>
            <div className='tableContainer'>
              <div className='tableHeader'>
                <a style={{width: '5%'}}></a>
                <a style={{width: '20%'}}>ФИО и электронная почта</a>
                <a style={{width: '55%'}}>Текст обращения</a>
                <a  style={{width: '20%'}}>Действие</a>
              </div>
              {loading && <Loading />}
              {warning && <div className='case warningLine'><a>{warning}</a></div>}
              {feedbacks.map((feedback) => (
                  <div className='user' key={feedback.id}>
                    <a style={{width: '5%', display: 'flex', justifyContent: 'center'}}>
                      {feedback.status == 'Открыто' ? 
                      (
                        <img src='/img/icons/circle.svg' alt='-' style={{height: '23px'}} />
                      ) 
                      : 
                      (
                        <img src='/img/icons/check-circle.svg' alt='-' style={{height: '23px'}} />
                      )}
                    </a>
                    <a style={{width: '20%'}}>{feedback.user_email}</a>
                    <a style={{width: '55%'}}>{feedback.message}</a>
                    <a style={{width: '20%', borderBottom: 'none', borderRight: 'none'}}>
                      {feedback.status == 'Открыто' ? 
                      (
                        <div style={{width: '100%', display: 'flex', flexDirection: 'column'}}>
                          <button type='button' className='button maxWidth' style={{height: '35px'}} onClick={(e) => changeStatusFeedback(e, feedback.id)}>Закрыть</button>
                        </div>
                      ) 
                      : 
                      (
                        <div style={{width: '100%', display: 'flex', flexDirection: 'column'}}>
                          <button type='button' className='button maxWidth' style={{height: '35px'}} onClick={(e) => changeStatusFeedback(e, feedback.id)}>Открыть</button>
                          <button type='button' className='button maxWidth' style={{height: '35px'}} onClick={(e) => deleteFeedback(e, feedback.id)}>Удалить</button>
                        </div>
                      )}
                    </a>
                  </div>
              ))}
            </div>
        </div>
    )
}

export default ViewFeedback;